import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { Building, Calendar, Calendar2, Clock, HddNetwork, LockFill, Map, Person, PinMap, TextParagraph } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export default function SiteInfos({ codesite }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [starting, setstarting] = useState(false);
    const [validing, setvaliding] = useState(false);
    const [suspending, setsuspending] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [validstate, setvalidstate] = useState(false);
    const [error, setError] = useState(false);

    const [nom, setnom] = useState("");
    const [desc, setdesc] = useState("");
    const [ippublic, setippublic] = useState("");
    const [portpublic, setportpublic] = useState("");
    const [userpublic, setuserpublic] = useState("");
    const [passpublic, setpasspublic] = useState("");
    const [iplocal, setiplocal] = useState("");
    const [portlocal, setportlocal] = useState("");
    const [userlocal, setuserlocal] = useState("");
    const [passlocal, setpasslocal] = useState("");
    const [long, setlong] = useState("");
    const [lat, setlat] = useState("");
    const [adresse, setadresse] = useState("");
    const [email, setemail] = useState('');
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);
    const [duree, setduree] = useState("");
    const [datedeb, setdatedeb] = useState("");
    const [datefin, setdatefin] = useState("");
    const [unite, setUnite] = useState({ label: "Année (s)", value: "years" });

    const unites = [
        {
            label: "Année (s)",
            value: "years",
        },
        // {
        //     label: "Mois",
        //     value: "months",
        // },
    ];

    const [datecrea, setDatecrea] = useState("");
    const [etatdef, setetatdef] = useState("");
    const [etat, setEtat] = useState(0);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getRevendeursList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            // if (element.abrevtypeutilisateur === "RVD") {
                            //     clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });
                            // }
                            clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });

                        });

                        setrevendeursList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites/${codesite}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];
                        let dureee = body?.duree !== null ? body?.duree.split(" ") : "";

                        setlong(body?.longit !== null ? body?.longit : "");
                        setlat(body?.latit !== null ? body?.latit : "");

                        setnom(body?.nom !== null ? body?.nom : "");
                        setemail(body?.email !== null ? body?.email : "");
                        setadresse(body?.adresse !== null ? body?.adresse : "");
                        setdesc(body?.descr !== null ? body?.descr : "");
                        setippublic(body?.ippublic !== null ? body?.ippublic : "");
                        setportpublic(body?.portpublic !== null ? body?.portpublic : "");
                        setuserpublic(body?.userpublic !== null ? body?.userpublic : "");
                        setpasspublic(body?.mdppublic !== null ? body?.mdppublic : "");
                        setiplocal(body?.iplocal !== null ? body?.iplocal : "");
                        setportlocal(body?.portlocal !== null ? body?.portlocal : "");
                        setuserlocal(body?.userlocal !== null ? body?.userlocal : "");
                        setpasslocal(body?.mdplocal !== null ? body?.mdplocal : "");

                        setduree(body?.duree !== null ? dureee[0] : "");
                        setUnite(body.duree !== null ? {
                            label:
                                dureee[1] === "année(s)"
                                    ? "Année (s)"
                                    : dureee[1] === "mois"
                                        ? "Mois"
                                        : dureee[1] === "jour(s)"
                                            ? "Jour (s)"
                                            : "",
                            value: dureee[1] === "année(s)"
                                ? "years"
                                : dureee[1] === "mois"
                                    ? "months"
                                    : dureee[1] === "jour(s)"
                                        ? "days"
                                        : "",
                        } : "");

                        setrevendeur(
                            body?.coderevendeur ? { label: body?.nomuser + " " + body?.prenom, value: body?.coderevendeur, } : ""
                        );
                        setetatdef(body?.etatdef !== null ? body?.etatdef : 0);
                        setEtat(body?.etat !== null ? body?.etat : 0);

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(
                            body?.datecrea !== null
                                ? body?.datecrea.slice(0, 16).replace("T", " à ")
                                : ""
                        );
                        setdatedeb(
                            body?.datedeb !== null
                                ? body?.datedeb.slice(0, 16).replace("T", " à ")
                                : ""
                        );
                        setdatefin(
                            body?.datefin !== null
                                ? body?.datefin.slice(0, 16).replace("T", " à ")
                                : ""
                        );

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    // comportements
    useEffect(() => {
        getElement();
        getRevendeursList();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deletesitelabel,
            message: textes.fr.deletesitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites/${codesite}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.sitedeletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setDeleting(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editsitelabel,
            message: textes.fr.editsitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (nom) urlencoded.append("nom", nom);
                        if (desc) urlencoded.append("descr", desc);
                        if (ippublic) urlencoded.append("ippublic", ippublic);
                        if (portpublic) urlencoded.append("portpublic", portpublic);
                        if (userpublic) urlencoded.append("userpublic", userpublic);
                        if (passpublic) urlencoded.append("passpublic", passpublic);
                        if (iplocal) urlencoded.append("iplocal", iplocal);
                        if (portlocal) urlencoded.append("portlocal", portlocal);
                        if (userlocal) urlencoded.append("userlocal", userlocal);
                        if (passlocal) urlencoded.append("passlocal", passlocal);
                        if (adresse) urlencoded.append("adresse", adresse);
                        if (long) urlencoded.append("long", long);
                        if (lat) urlencoded.append("lat", lat);
                        urlencoded.append("coderevendeur", (user?.isFullAction || user?.isAdminAction) ? revendeur["value"] : user?.codeutilisateur);
                        urlencoded.append("etatdef", etatdef);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);
                        // console.log("data send", urlencoded)

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites/${codesite}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.siteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editsitelabel,
            message: textes.fr.editsitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setsuspending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "3");
                        urlencoded.append("etatdef", "Suspendu");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites/${codesite}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.siteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setsuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setsuspending(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setsuspending(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setsuspending(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editsitelabel,
            message: textes.fr.editsitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setstarting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Validé");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites/${codesite}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.siteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setstarting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setstarting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setstarting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setstarting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleValide = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editsitelabel,
            message: textes.fr.editsitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setvaliding(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("nom", nom);
                        urlencoded.append("email", email);
                        if (ippublic) urlencoded.append("ippublic", ippublic);
                        if (portpublic) urlencoded.append("portpublic", portpublic);
                        if (userpublic) urlencoded.append("userpublic", userpublic);
                        if (passpublic) urlencoded.append("passpublic", passpublic);
                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Validé");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites/${codesite}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.siteupdatedlabel);
                                setEditedstate(false);
                                setvalidstate(false);
                                getElement();
                                setvaliding(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setvaliding(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setvaliding(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setvaliding(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isAdminAction || user?.isModifierSite) && !editedstate && (
                                            <button
                                                onClick={() => setEditedstate(true)}
                                                title={textes.fr.editsitelabel}
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right"
                                            >
                                                <i className="fa fa-edit mr-1"></i>{" "}
                                                <span>{textes.fr.edit}</span>
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSupprimerSite) && !editedstate && (etat === 1 || etat === 3) && (
                                            <button
                                                onClick={handleDelete}
                                                title={textes.fr.deletesitelabel}
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                            >
                                                <i className="fa fa-trash mr-1"></i>{" "}
                                                <span>{textes.fr.delete}</span>{" "}
                                                {deleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isValiderSite) && !editedstate && etat === 1 && <button
                                            onClick={() => {
                                                setvalidstate(true);
                                                setEditedstate(true);
                                            }}
                                            title="Valider le site"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-check-circle mr-1"></i> <span>Valider</span>
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isActiverSite) && !editedstate && etat === 3 && <button onClick={handleStart}
                                            title="Réactiver le site"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-arrow-up mr-1"></i> <span>Ré-activer</span>  {starting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSuspendreSite) && !editedstate && etat === 2 && <button onClick={handleSuspende}
                                            title="Suspendre le site"
                                            className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                            <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        <h5 className="m-0 ">
                                            {textes.fr.siteinfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {!validstate && <form style={{ width: "100%" }} className="mb-3" onSubmit={handleSubmitEdit}>
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="row">
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="revendeur" className="mb-1">
                                                                {textes.fr.revendeurlabel}
                                                            </label>
                                                            <Select
                                                                id="revendeur"
                                                                name="revendeur"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={revendeursList}
                                                                value={revendeur}
                                                                onChange={(selected) => {
                                                                    setrevendeur(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>}
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="nom" className="mb-1">
                                                                Nom du site
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="nom"
                                                                >
                                                                    <Building />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={nom}
                                                                    onChange={(e) =>
                                                                        setnom(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="adresse" className="mb-1">
                                                                Adresse
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="adresse"
                                                                >
                                                                    <Map />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={adresse}
                                                                    onChange={(e) =>
                                                                        setadresse(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="ippublic" className="mb-1">
                                                                Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="ippublic"
                                                                >
                                                                    <HddNetwork />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={ippublic}
                                                                    onChange={(e) => { setippublic(e.target.value) }}

                                                                    disabled={(editedstate && (user?.isFullAction || user?.isAdminAction)) ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="portpublic" className="mb-1">
                                                                Port Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="portpublic"
                                                                >
                                                                    <HddNetwork />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={portpublic}
                                                                    onChange={(e) => { setportpublic(e.target.value) }}

                                                                    disabled={(editedstate && (user?.isFullAction || user?.isAdminAction)) ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="userpublic" className="mb-1">
                                                                User Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="userpublic"
                                                                >
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={userpublic}
                                                                    onChange={(e) => { setuserpublic(e.target.value) }}

                                                                    disabled={(editedstate && (user?.isFullAction || user?.isAdminAction)) ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="passpublic" className="mb-1">
                                                                Password Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="passpublic"
                                                                >
                                                                    <LockFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={passpublic}
                                                                    onChange={(e) => { setpasspublic(e.target.value) }}

                                                                    disabled={(editedstate && (user?.isFullAction || user?.isAdminAction)) ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="iplocal" className="mb-1">
                                                                Adresse IP Local
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="iplocal"
                                                                >
                                                                    <HddNetwork />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={iplocal}
                                                                    onChange={(e) => { setiplocal(e.target.value) }}

                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="portlocal" className="mb-1">
                                                                Port Adresse IP Local
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="portlocal"
                                                                >
                                                                    <HddNetwork />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={portlocal}
                                                                    onChange={(e) => { setportlocal(e.target.value) }}

                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="userlocal" className="mb-1">
                                                                User Adresse IP Local
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="userlocal"
                                                                >
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={userlocal}
                                                                    onChange={(e) => { setuserlocal(e.target.value) }}

                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="passlocal" className="mb-1">
                                                                Password Adresse IP Local
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="passlocal"
                                                                >
                                                                    <LockFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={passlocal}
                                                                    onChange={(e) => { setpasslocal(e.target.value) }}

                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="long" className="mb-1">
                                                                Longitude
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="long"
                                                                >
                                                                    <PinMap />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={long}
                                                                    onChange={(e) => { setlong(e.target.value) }}
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="lat" className="mb-1">
                                                                Latitude
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="lat"
                                                                >
                                                                    <PinMap />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={lat}
                                                                    onChange={(e) => { setlat(e.target.value) }}
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="desc" className="mb-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="desc"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={desc}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setdesc(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="duree" className="mb-1">
                                                                {textes.fr.durelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="duree"
                                                                >
                                                                    <Clock />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={duree}
                                                                    onChange={(e) =>
                                                                        setduree(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="unite" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="unite"
                                                                name="unite"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unites}
                                                                value={unite}
                                                                onChange={(selected) => {
                                                                    setUnite(selected);
                                                                }}
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="datedeb" className="mb-1">Date début</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="datedeb"
                                                                >
                                                                    <Calendar />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={datedeb}
                                                                    onChange={(e) =>
                                                                        setdatedeb(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="datefin" className="mb-1">Date fin</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="datefin"
                                                                >
                                                                    <Calendar />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={datefin}
                                                                    onChange={(e) =>
                                                                        setdatefin(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="etat" className="mb-1">Etat</label>
                                                            <div className="input-group flex-nowrap">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    className={`form-control 
                                                                        ${etat === 1 ? "text-white bg-warning" :
                                                                            etat === 2 ? "text-white bg-success" :
                                                                                (etat === 3 || etat === 4) ? "text-white bg-danger" :
                                                                                    ""
                                                                        }`}
                                                                    id="etat"
                                                                    value={etatdef}
                                                                    onChange={(e) => setEtat(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                {textes.fr.addeddatelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {editedstate && (
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.editsitelabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Modifier</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => setEditedstate(false)}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </form>}
                                        {validstate && <form style={{ width: "100%" }} className="mb-3" onSubmit={handleValide}>
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="nom" className="mb-1">
                                                                Nom du site
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="nom">
                                                                    <Building />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={nom}
                                                                    onChange={(e) =>
                                                                        setnom(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="adresse" className="mb-1">
                                                                Adresse
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="adresse">
                                                                    <Map />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={adresse}
                                                                    onChange={(e) =>
                                                                        setadresse(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="ippublic" className="mb-1">
                                                                Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="ippublic"
                                                                >
                                                                    <HddNetwork />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={ippublic}
                                                                    onChange={(e) => { setippublic(e.target.value) }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="portpublic" className="mb-1">
                                                                Port Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="portpublic"
                                                                >
                                                                    <HddNetwork />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={portpublic}
                                                                    onChange={(e) => { setportpublic(e.target.value) }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="userpublic" className="mb-1">
                                                                User Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="userpublic"
                                                                >
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={userpublic}
                                                                    onChange={(e) => { setuserpublic(e.target.value) }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label htmlFor="passpublic" className="mb-1">
                                                                Password Adresse IP Public
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="passpublic"
                                                                >
                                                                    <LockFill />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={passpublic}
                                                                    onChange={(e) => { setpasspublic(e.target.value) }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-2">
                                                    <button
                                                        type="submit"
                                                        title={textes.fr.editsitelabel}
                                                        className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        disabled={portpublic && ippublic && userpublic && passpublic ? false : true}
                                                    >
                                                        <i className="fa fa-check mr-2"></i>
                                                        <span>Valider</span>{" "}
                                                        {validing && (
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        )}
                                                    </button>
                                                    <button
                                                        onClick={() => { setEditedstate(false); setvalidstate(false) }}
                                                        title={textes.fr.cancel}
                                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                    >
                                                        <i className="fa fa-reply mr-1"></i>{" "}
                                                        <span>{textes.fr.cancel}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
